import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 公共请求封装模块（所有 api/*.js 均 import 此实例）
// 基于 axios 创建全局单例；统一配置 baseURL、超时、请求/响应拦截器
// 鉴权方式：请求头 Authorization: Bearer <token>（token 取自 localStorage.admin_user）
// 统一异常处理：401/403 均视为登录态失效（token 过期或丢失），清除登录态并跳登录页重新获取 token；其他/网络异常提示错误信息

// 后端基地址由环境变量驱动：
//   - 开发环境：.env.development 中 VUE_APP_API_BASE_URL=http://localhost:8088
//   - 生产环境：.env.production 中 VUE_APP_API_BASE_URL=（空串）→ 走同域 /api/v1，由 nginx 反代到后端
// 注意：VUE_APP_ 前缀是 Vue CLI 注入环境变量的硬性要求，其他前缀不会被打包进前端。
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '', // 生产环境为空→请求落当前域 /api/v1；开发环境 http://localhost:8088
  timeout: 15000 // 请求超时时间（毫秒）
})

// 请求拦截器 - 自动带 JWT token
request.interceptors.request.use(
  config => {
    const user = localStorage.getItem('admin_user')
    if (user) {
      try {
        const u = JSON.parse(user)
        if (u.token) {
          config.headers['Authorization'] = 'Bearer ' + u.token
        }
      } catch (e) {}
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器 - 统一处理 401/403
request.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      const { status } = error.response
      // 401/403 统一视为登录态失效（token 过期/丢失）→ 清除登录态并跳登录页重新登录
      // 403 在生产环境通常为 JWT token 过期导致鉴权失败，而非真实权限不足
      if (status === 401 || status === 403) {
        localStorage.removeItem('admin_user')
        Message.error('登录已过期，请重新登录')
        if (router.currentRoute.path !== '/login') {
          router.push('/login')
        }
      } else {
        Message.error(error.response.data?.message || '请求失败')
      }
    } else {
      Message.error('网络异常，请检查网络连接')
    }
    return Promise.reject(error)
  }
)

export default request
